/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './bulk-delete-rest.service';
export * from './bulk-delete.dto';
export * from './bulk-delete.mapper';
